import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { MY_PAGE_PATH } from '@/shared/config';
import { cn } from '@/shared/ui';

const UTILITY_LINK_CLASS = {
  default: 'text-foreground/80 transition-colors hover:text-foreground',
  inverse: 'text-white/85 transition-colors hover:text-white',
} as const;

interface SiteHeaderMemberNavProps {
  readonly isSignedIn: boolean;
  readonly onSignOut: () => void;
  /** 메뉴 목록 글자·간격 — 헤더 배치(알약·쌓은 배치)마다 다르다. */
  readonly listClassName: string;
  /** inverse = 사진 위 흰 글자(HOME 접힌 헤더). */
  readonly tone?: 'default' | 'inverse';
}

/** 넓은 화면(xl 이상)의 회원 메뉴 — 로그인 상태별 링크. 관리자 앱은 홈페이지에서 링크하지 않는다(주소를 따로 전달). */
export const SiteHeaderMemberNav = ({
  isSignedIn,
  onSignOut,
  listClassName,
  tone = 'default',
}: SiteHeaderMemberNavProps): ReactElement => (
  <nav aria-label="회원 메뉴" className="hidden justify-self-end xl:block">
    <ul className={cn('flex items-center whitespace-nowrap', listClassName)}>
      {isSignedIn ? (
        <>
          <li>
            <Link to={MY_PAGE_PATH} className={UTILITY_LINK_CLASS[tone]}>
              마이페이지
            </Link>
          </li>
          <li>
            <button type="button" onClick={onSignOut} className={UTILITY_LINK_CLASS[tone]}>
              로그아웃
            </button>
          </li>
        </>
      ) : (
        <>
          <li>
            <Link to="/sign-in" className={UTILITY_LINK_CLASS[tone]}>
              로그인
            </Link>
          </li>
          <li>
            <Link to="/sign-up" className={UTILITY_LINK_CLASS[tone]}>
              회원가입
            </Link>
          </li>
        </>
      )}
    </ul>
  </nav>
);
